document.addEventListener('DOMContentLoaded', function() {
    function isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            || window.innerWidth <= 768;
    }

    const videoBlocks = document.querySelectorAll('.video');

    videoBlocks.forEach(function(block) {
        const textVideo = block.querySelector('.video__video');
        if (!textVideo) return;

        if (isMobileDevice()) return;

        // Remove stale src="null" written by old block versions so <source> can work.
        if (textVideo.getAttribute('src') === 'null') {
            textVideo.removeAttribute('src');
        }

        const rawVideoUrl = textVideo.getAttribute('data-video-url');
        const sourceEl    = textVideo.querySelector('source');

        // Resolve the actual video URL: prefer data-video-url, fall back to <source>.
        let effectiveUrl = (rawVideoUrl && rawVideoUrl !== 'null') ? rawVideoUrl : null;
        if (!effectiveUrl && sourceEl) {
            effectiveUrl = sourceEl.getAttribute('src') || sourceEl.getAttribute('data-src') || null;
            // Lazy-load the <source>: hold the real src until the block is in viewport.
            if (effectiveUrl && sourceEl.getAttribute('src')) {
                sourceEl.setAttribute('data-src', effectiveUrl);
                sourceEl.removeAttribute('src');
            }
        }

        if (!effectiveUrl) return;

        const pauseBtn = block.querySelector('.video__pause-btn');
        let isVideoLoaded = false;
        let isPaused = false;

        function updateButtonState(paused) {
            if (!pauseBtn) return;
            pauseBtn.classList.toggle('paused', paused);
            var pauseIcon = pauseBtn.querySelector('.video__pause-icon');
            var playIcon  = pauseBtn.querySelector('.video__play-icon');
            if (pauseIcon) pauseIcon.style.display = paused ? 'none' : '';
            if (playIcon)  playIcon.style.display  = paused ? '' : 'none';
        }

        function startPlayback() {
            textVideo.play().then(function() {
                isPaused = false;
                updateButtonState(false);
            }).catch(function() {});
        }

        function loadVideoSource() {
            if (isVideoLoaded) return;
            if (rawVideoUrl && rawVideoUrl !== 'null') {
                // New block format: src stored in data-video-url attribute.
                textVideo.src = effectiveUrl;
            } else if (sourceEl && sourceEl.getAttribute('data-src')) {
                // Old block format: restore src onto <source> element.
                sourceEl.src = sourceEl.getAttribute('data-src');
            }
            textVideo.load();
            isVideoLoaded = true;
        }

        function toggleVideo() {
            if (isPaused) {
                textVideo.play().then(function() {
                    isPaused = false;
                    updateButtonState(false);
                }).catch(function() {});
            } else {
                textVideo.pause();
                isPaused = true;
                updateButtonState(true);
            }
        }

        if (pauseBtn) {
            pauseBtn.addEventListener('click', function(e) {
                e.preventDefault();
                toggleVideo();
            });
        }

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && !isVideoLoaded) {
                    loadVideoSource();
                    textVideo.addEventListener('canplaythrough', function() {
                        if (!isPaused) startPlayback();
                    }, { once: true });
                }
            });
        }, {
            rootMargin: '100px',
            threshold: 0.1
        });

        observer.observe(block);

        if ('requestIdleCallback' in window) {
            requestIdleCallback(function() {
                if (!isVideoLoaded) {
                    loadVideoSource();
                    textVideo.addEventListener('canplaythrough', function() {
                        if (!isPaused) startPlayback();
                    }, { once: true });
                }
            }, { timeout: 2000 });
        } else {
            setTimeout(function() {
                if (!isVideoLoaded) {
                    loadVideoSource();
                    textVideo.addEventListener('canplaythrough', function() {
                        if (!isPaused) startPlayback();
                    }, { once: true });
                }
            }, 2000);
        }
    });
});